declare namespace $ {

	type $shm_hitalama_color_dot__color_shm_hitalama_color_pick_1 = $mol_type_enforce<
		ReturnType< $shm_hitalama_color_pick['color'] >
		,
		ReturnType< $shm_hitalama_color_dot['color'] >
	>
	type $shm_hitalama_color_switch__value_shm_hitalama_color_pick_2 = $mol_type_enforce<
		ReturnType< $shm_hitalama_color_pick['color'] >
		,
		ReturnType< $shm_hitalama_color_switch['value'] >
	>
	type $shm_hitalama_color_switch__event_shm_hitalama_color_pick_3 = $mol_type_enforce<
		({ 
			click( next?: ReturnType< $shm_hitalama_color_pick['click'] > ): ReturnType< $shm_hitalama_color_pick['click'] >,
		}) 
		,
		ReturnType< $shm_hitalama_color_switch['event'] >
	>
	type $shm_hitalama_color_switch__colors_shm_hitalama_color_pick_4 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $shm_hitalama_color_switch['colors'] >
	>
	export class $shm_hitalama_color_pick extends $mol_pick {
		Current( ): $shm_hitalama_color_dot
		color_default( ): string
		color( next?: ReturnType< $shm_hitalama_color_pick['color_default'] > ): ReturnType< $shm_hitalama_color_pick['color_default'] >
		click( next?: any ): any
		Colors( ): $shm_hitalama_color_switch
		trigger_content( ): readonly(any)[]
		bubble_content( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=pick.view.tree.d.ts.map